import { generateId, TIPTAP_IMAGE_TYPE } from "./../../ricos-content";
import imageDataDefaults from "./../../ricos-schema/legacy/statics/image.defaults.json";
import { createRicosNodeExtension, Uploader } from "./../../plugin-commons";
import { ImagePluginService } from "../toolbar/imagePluginService";
import { EditorImage as Component } from "./component";
const name = TIPTAP_IMAGE_TYPE;
const tiptapExtensions = [
  createRicosNodeExtension({
    type: "react-node",
    name,
    groups: ["spoilerable", "resizable", "draggable", "not-overtypable"],
    reconfigure: (config, _extensions, _props, settings, services) => ({
      ...config,
      addOptions: () => ({
        services,
        imagePluginService: new ImagePluginService(),
        ...settings
      })
    }),
    Component,
    createExtensionConfig({ Plugin, PluginKey }) {
      return {
        name: this.name,
        atom: false,
        group: "block",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          ...imageDataDefaults,
          loading: {
            default: false
          },
          loadingPercentage: {
            default: null
          },
          tempData: {
            default: null
          }
        }),
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: new PluginKey("handlePasteImage"),
              props: {
                handlePaste: (_, event) => {
                  let hasFiles = false;
                  if (event?.clipboardData?.types.includes("text/plain")) {
                    return false;
                  }
                  Array.from(event?.clipboardData?.files || []).filter((file) => file.type.startsWith("image")).forEach((file) => {
                    const nodeId = generateId();
                    this.editor.commands.insertContent({
                      type: TIPTAP_IMAGE_TYPE,
                      attrs: { id: nodeId }
                    });
                    this.options.services?.uploadService?.uploadFile(
                      file,
                      nodeId,
                      new Uploader(this.options.handleFileUpload),
                      TIPTAP_IMAGE_TYPE,
                      this.options.imagePluginService
                    );
                    hasFiles = true;
                  });
                  if (hasFiles) {
                    event.preventDefault();
                    return true;
                  }
                  return false;
                }
              }
            })
          ];
        },
        addCommands() {
          return {
            setImageUrl: (url) => ({ commands }) => {
              return commands.updateAttributes(name, { image: { src: { custom: url } } });
            },
            setImageLoading: (loading) => ({ commands }) => {
              return commands.updateAttributes(name, { loading });
            }
          };
        }
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
